// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"c5da6aed","194":"e928b889","206":"ee475449","334":"d07b13f6","601":"95f26e59","811":"187e07ce","933":"b13d9fbd"}[chunkId] + ".chunk.js";
};